import { req } from '../@api/request';

interface ChangeStatus {
  userid: string;
  state: string;
}

export default class UserService {
  static userList = async (
    branchcode: number | undefined,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `users/list?branchcode=${branchcode}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
  static changeStatus = async (data: ChangeStatus) => {
    const result = await req.patch('/users/sign/approval', data);
    return result.data;
  };
  static userInfo = async () => {
    const result = await req.get(`users/info`);
    return result.data;
  };
  static userGrade = async () => {
    const result = await req.get(`users/info`);
    if (result.data.data.plan_grade === 'T' || result.data.data.plan_grade === 'S' || result.data.data.plan_grade === 'P') {
      return true
    } else {
      return false
    }
  };
  static changePassword = async (data: any) => {
    const result = await req.post('/users/update/password', data);
    return result.data;
  };
  static SendSms = async (data: any) => {
    const result = await req.post(`/users/auth/otp/send`, data);
    return result.data;
  };
  static CheckCode = async (data: any) => {
    const result = await req.post(`/users/auth/otp/verify`, data);
    return result.data;
  };
  static updateUserInfo = async (data: any) => {
    const result = await req.post(`/users/update`, data);
    return result.data;
  };
  static updateProfile = async (data: any) => {
    const result = await req.post(`/users/update/img`, data);
    return result.data;
  };
}
